import { Box } from '@chakra-ui/react';
import React from 'react';

/**
 * Loading view, displayed while CreditFacilitySummaries are fetched from backend
 */
export const LoadingView = () => <Box />;
